import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { useTranslation } from 'react-i18next';
import ContentApp from '../../ContentApp';
import Header from '../../Common/Header/Header';
import styles from './LoyaltyCardCustomer.module.css';
import AdvantageIcon from '../../icons/AdvantageIcon';
import WalletIcon from '../../icons/WalletIcon';
import { Spinner } from '../../Common/Spinner/Spinner';
import { getDevice } from '../../../helpers/device';
import Qr from '../../Common/Qr/Qr';
import { getQrImage } from '../../../helpers/qr';
import { format, parseISO } from 'date-fns';
import { getLocale } from '../../../helpers/dates';

const LoyaltyCardCustomer = () => {
  const welletContext = useContext(WelletContext);
  const isIOS = getDevice() === 'iOS';
  const associate = useSelector((state) => state.associates);
  const user = associate.user;
  const app = useSelector((state) => state.app);
  const language = useSelector((state) => state.app.language);
  const [addingToWallet, setAddingToWallet] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const locale = getLocale(language);
  const isoLogo = app.media.find((m) => m.type === 'ISO_LOGO').value;
  const isoLogoTransparent = app.media.find((m) => m.type === 'ISO_LOGO_TRANSPARENT').value;
  const { t } = useTranslation();
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const downloadPKPass = (data) => {
    const { stream, type, fileName } = data;
    if (type === 'application/vnd.apple.pkpass') {
      const byteCharacters = atob(stream);
      const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type });
      const fileUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(fileUrl);
    } else {
      console.error('El tipo de archivo no es un PKPass.');
    }
  };

  const walletGoogle = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/google?token=${token}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const walletApple = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/apple?token=${token}`);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleWellet = async (tokenWellet) => {
    setAddingToWallet(true);
    try {
      if (isIOS) {
        const response = await walletApple(tokenWellet);
        downloadPKPass(response.data);
      } else if (isMounted) {
        const url = await walletGoogle(tokenWellet);
        if (url) {
          window.open(url);
        } else {
          console.error('No se recibió una URL válida de Google Wallet');
        }
      }
    } catch (error) {
      console.error('Error al agregar a la billetera:', error);
    } finally {
      setAddingToWallet(false);
    }
  };

  return (
    <>
      <Header color={'#FFF'} />
      <ContentApp>
        <div className='card' style={{ borderRadius: '15px' }}>
          <div className='p-3 d-flex justify-content-between align-items-center'>
            <img src={isoLogoTransparent} alt={app.name} className={styles.img} />
            <div>
              <div className='text-secondary'>{t('number')}</div>
              <div>{user.qrCode}</div>
            </div>
          </div>

          <div className={styles.imgCardContainer}>
            <img src={'../../images/loyaltyCard.png'} className={styles.imgCard} />
            <div className={styles.overlay}>
              <AdvantageIcon color='#7e7e7e' size={31} />
              <span>
                {t('member')} {user.currentLoyalty.category}
              </span>
            </div>
          </div>

          <div>
            <div className='p-3 d-flex justify-content-between align-items-center'>
              <div>
                <div className='text-secondary'>{t('member')}</div>
                <div>{user.name}</div>
              </div>
              <div>
                <div className='text-secondary'>{t('validThru')}</div>
                <div style={{ textAlign: 'right' }}>
                  {format(parseISO(user.currentLoyalty.closedCategorization), 'MM / yy', {
                    locale,
                  })}
                </div>
              </div>
            </div>

            <div className={`${styles.qrLoyalty}`}>
              <div className='mt-3'>
                <Qr
                  qrUrl={user.qrUserUrl}
                  getQrImage={getQrImage}
                  welletContext={welletContext}
                  logo={isoLogo}
                  logoBorder='ROUNDED'
                />
              </div>
            </div>
          </div>
        </div>
      </ContentApp>
    </>
  );
};

export default LoyaltyCardCustomer;
